import { Suspense } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ScrollToTop } from "@/components/ScrollToTop";
import { ThemeProvider } from "@/components/ThemeProvider";
import { PWAInstallPrompt } from "@/components/PWAInstallPrompt";
import { PushNotificationPrompt } from "@/components/PushNotificationPrompt";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import SobreUmbanda from "./pages/SobreUmbanda";
import QuemSomos from "./pages/QuemSomos";
import TrabalhosEspirituais from "./pages/TrabalhosEspirituais";
import Normas from "./pages/Normas";
import Doacoes from "./pages/Doacoes";
import Contato from "./pages/Contato";
import Galeria from "./pages/Galeria";
import Biblioteca from "./pages/Biblioteca";
import Admin from "./pages/Admin";
import Auth from "./pages/Auth";
import Agendamento from "./pages/Agendamento";
import Profile from "./pages/Profile";
import ResetPassword from "./pages/ResetPassword";
import Unsubscribe from "./pages/Unsubscribe";
import VerifyEmail from "./pages/VerifyEmail";
import Instalar from "./pages/Instalar";

const queryClient = new QueryClient();

const App = () => (
  <Suspense fallback={<div className="min-h-screen flex items-center justify-center">Carregando...</div>}>
    <ThemeProvider defaultTheme="system" storageKey="tupja-theme">
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/sobre-umbanda" element={<SobreUmbanda />} />
              <Route path="/quem-somos" element={<QuemSomos />} />
              <Route path="/trabalhos-espirituais" element={<TrabalhosEspirituais />} />
              <Route path="/normas" element={<Normas />} />
              <Route path="/doacoes" element={<Doacoes />} />
              <Route path="/galeria" element={<Galeria />} />
              <Route path="/biblioteca" element={<Biblioteca />} />
              <Route path="/contato" element={<Contato />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/agendamento" element={<Agendamento />} />
              <Route path="/agendamento-seu-ze" element={<Agendamento />} />
              <Route path="/perfil" element={<Profile />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/unsubscribe" element={<Unsubscribe />} />
              <Route path="/verificar-email" element={<VerifyEmail />} />
              <Route path="/instalar" element={<Instalar />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
            <PWAInstallPrompt />
            <PushNotificationPrompt />
          </BrowserRouter>
        </TooltipProvider>
      </QueryClientProvider>
    </ThemeProvider>
  </Suspense>
);

export default App;
